export default __webpack_public_path__ + "static/Logo-BCH-b38eebf1be6da0d0c2c5b3929dc03e8e.png";